import { createContentfulProps } from "frontend/contentful/lib/create-contentful-props";
import { MediaCarouselEntry } from "frontend/contentful/schema/blocks";
import { MediaCarouselProps } from "design-system/components/blocks/media-carousel/media-carousel";
import { MediaCarouselOptions } from "./media-carousel.contentful";
import { useContentful } from "frontend/hooks/use-contentful";

import { createComponentHeaderProps } from "../primitives/component-header.props";
import { createRichMediaAssetProps } from "../primitives/media-asset.props";
import { createCtaLinkProps } from "../primitives/cta-link.props";
export const createMediaCarouselProps = createContentfulProps<
  MediaCarouselEntry,
  MediaCarouselProps,
  MediaCarouselOptions
>(({ entry, options }) => {
  const headerAbove = options?.headerAbove || false;
  const { getEntry, getEntries } = useContentful();
  const header = getEntry(entry.fields.header);
  const headerProps = createComponentHeaderProps(header);
  const props: MediaCarouselProps = {
    headerContent: headerProps,
    items: [],
    align: entry.fields.alignment,
    HeadingLevel: headerAbove ? "h3" : "h2",
  };

  getEntries(entry.fields.mediaCarouselItem).forEach((item) => {
    const mediaAssetProps = createRichMediaAssetProps(item.fields.media);
    const ctaLinkProps = createCtaLinkProps(item.fields.ctaLink);

    if (mediaAssetProps) {
      props.items?.push({
        media: mediaAssetProps,
        ctaLink: ctaLinkProps,
      });
    }
  });

  return props;
});
